import { userConstants } from './constantData';

export const ERRORS_DATA = {
  error_logout: {
    page_view: {
      hash: 'p-041.023.000.000.000.000',
      event: 'pages',
      dimensions: [
        ...userConstants,
        'v_error_type',
        'v_error_code',
        'v_api',
      ],
    },
  },
};
